import axios from "axios";
import { baseURL } from "./API";

/**
 * Dedupes dashboard API calls across Strict Mode remounts and duplicate hook instances.
 * One in-flight request per endpoint per auth token.
 */
const cache = {
	token: null,
	dailySummary: null,
	dashboard: null,
	dailySummaryPromise: null,
	dashboardPromise: null,
};

export const clearDashboardFetchCache = () => {
	cache.token = null;
	cache.dailySummary = null;
	cache.dashboard = null;
	cache.dailySummaryPromise = null;
	cache.dashboardPromise = null;
};

const ensureToken = (token) => {
	if (token !== cache.token) {
		clearDashboardFetchCache();
		cache.token = token;
	}
};

export const fetchDailySummaryDeduped = async (token) => {
	if (!token) return null;
	ensureToken(token);
	if (cache.dailySummary) return cache.dailySummary;
	if (!cache.dailySummaryPromise) {
		axios.defaults.headers.common.Authorization = `Bearer ${token}`;
		cache.dailySummaryPromise = axios
			.get(`${baseURL}/landlords/dashboard/daily_summary`)
			.then((res) => {
				cache.dailySummary = res.data?.data ?? null;
				return cache.dailySummary;
			})
			.finally(() => {
				cache.dailySummaryPromise = null;
			});
	}
	return cache.dailySummaryPromise;
};

export const fetchAdminDashboardDeduped = async (token) => {
	if (!token) return null;
	ensureToken(token);
	if (cache.dashboard) return cache.dashboard;
	if (!cache.dashboardPromise) {
		axios.defaults.headers.common.Authorization = `Bearer ${token}`;
		cache.dashboardPromise = axios
			.get(`${baseURL}/landlords/admin/dashboard`)
			.then((res) => {
				cache.dashboard = res.data?.data ?? {};
				return cache.dashboard;
			})
			.finally(() => {
				cache.dashboardPromise = null;
			});
	}
	return cache.dashboardPromise;
};
